/**
 * `Layer.bindTooltip(string, ...)` (Leaflet, not react-leaflet's own JSX
 * `<Tooltip>` — see its own usages in SubBasinMap.tsx, safe by construction
 * since React escapes JSX children) sets its content via `innerHTML`, with
 * no escaping of its own. Every caller here builds tooltip text from
 * sub-basin/zone/outlet-point/aquifer names, shapefile attributes (CodMasa),
 * or MITECO basin names — all user-renamable or imported-from-an-untrusted-
 * file text, not app-controlled strings — so every dynamic piece needs to
 * go through this before reaching `bindTooltip`, or a name/attribute value
 * containing e.g. `<img src=x onerror=...>` would execute as real markup
 * for anyone who opens that project/shapefile.
 *
 * Its own module (not just exported from SubBasinMap.tsx, which is where it
 * used to live) because MitecoSelectableLayer.tsx/MitecoBasinPickerMap.tsx
 * both need it too, and importing it from SubBasinMap.tsx created a real
 * circular import (SubBasinMap.tsx -> MitecoBasinsLayer.tsx/
 * MitecoSubBasinsLayer.tsx -> MitecoSelectableLayer.tsx -> back to
 * SubBasinMap.tsx) — found in the 2026-08-24 structure/maintainability
 * review.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
